import React from 'react';
import { Link } from 'react-router-dom';

// Utility function to handle different URL formats based on action type
const getActionUrl = (url, type) => {
  switch (type) {
    case 'email':
      return `mailto:${url}`;
    case 'phone':
      return `tel:${url}`;
    case 'whatsapp':
      return `https://wa.me/${url}`;
    case 'url':
    default:
      return url;
  }
};

const ActionLink = ({ url, type }) => {
  // Get the correctly formatted URL based on the type
  const formattedUrl = getActionUrl(url, type);

  return <Link to={formattedUrl} className="delete-widget">{url}</Link>;
};

export default ActionLink;
